$(function () {
    $(".plp1xfilter .filter-label").on("click", function (e) {
        pushOtherEvent("gaEvent", "filterClick", $(this).html(), undefined);
    });

    $(".mobile-facets__footer button[type=button]").on("click", function (e) {
        var labelArrays = {
            availability: customGetUrlParameter("filter.v.availability"),
            prMin: customGetUrlParameter("filter.v.price.gte"),
            prMax: customGetUrlParameter("filter.v.price.lte"),
            brand: customGetUrlParameter("filter.p.vendor"),
            type: customGetUrlParameter("filter.p.product_type"),
            tags: customGetUrlParameter("filter.p.tag"),
        };

        var label = Object.keys(labelArrays)
            .map((key) =>
                labelArrays[`${key}`] !== false
                    ? labelArrays[`${key}`].join("_")
                    : "none"
            )
            .join("-");

        var action = "availability-price_gte-price_lte-vendor-product_type-tag";
        pushOtherEvent("gaEvent", "filterClick", action, label);
    });

    $("div.footer-menu div.nested_links a").on("click", function (e) {
        var label = $(this).html().trim();

        var action = $(this).attr("data-G-action");

        pushOtherEvent("gaEvent", "navigation_footer", action, label);
    });

    $("a.cclinks").on("click", function (e) {
        var label = $(this).attr("data-G-label");

        var action = $(this).attr("data-g-action");

        pushOtherEvent("gaEvent", "navigation_header", action, label);
    });

    $(".button-book").on("click", function (evt) {
        pushOtherEvent("gaEvent", "restaurant_book", "cta-click", undefined);
    });

    $(".button-reserve").on("click", function (evt) {
        pushOtherEvent("gaEvent", "room_book", "cta-click", undefined);
    });

    var form = document.getElementById("EventContactForm");

    if (form) {
        var form_type = form.querySelector("[name=form_type]").value,
            inputs = form.querySelectorAll("[name]"),
            alert = form.querySelector('[data-alert="status"]'),
            alert_msgs = form.querySelector(".form-alerts");

        form.addEventListener("submit", (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            if ($("form#EventContactForm #event-newsletter-checkbox")[0].checked) {
                var action = form.getAttribute("action");
                if (alert_msgs) {
                    var alert_msg = JSON.parse(alert_msgs.innerHTML);
                }
                fetch(action, {
                    method: "POST",
                    body: getUrlString(formToJSON(inputs)),
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                        Accept: "text/html, */*; q=0.01",
                        "X-Requested-With": "XMLHttpRequest",
                    },
                })
                    .then(function (response) {
                        $("#ContactEventNewsletter .newsletter-input-field").attr(
                            "value",
                            $("#ContactForm-email")[0].value
                        );

                        $("#ContactEventNewsletter").submit();
                    })
                    .catch(function (err) {
                        console.error(err);
                        if (alert) {
                            alert.className = "alert alert-error";
                            alert.innerHTML = alert_msg.error;
                        }
                    });
            } else {
                e.target.submit();
            }
        });
    }
});

function pushOtherEvent(event, category, action, label) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: event,
        category: category,
        action: action,
        label: label,
    });
}

function formToJSON(elements) {
    return [].reduce.call(
        elements,
        function (data, element) {
            data[element.name] = element.value;
            return data;
        },
        {}
    );
}

// Get Shopify Friendly URL String
function getUrlString(data) {
    var urlParameters = Object.entries(data)
        .map(function (e) {
            return e.join("=");
        })
        .join("&");

    return urlParameters;
}
